import { merge } from 'ramda'
import { createReducer } from '../lib/reducer'
import ActionTypes from '../actions/types'

const initialState = {
  showWelcomeBackBanner: false
}

const ui = createReducer(initialState, {
  [ActionTypes.SET_SHOW_WELCOME_BACK_BANNER]: (state, { payload }) => {
    return merge(state, { showWelcomeBackBanner: payload })
  }
})

export default ui
